import { render, staticRenderFns } from "./uploadArquivos.vue?vue&type=template&id=d1a1f162&scoped=true&"
import script from "./uploadArquivos.vue?vue&type=script&lang=js&"
export * from "./uploadArquivos.vue?vue&type=script&lang=js&"
import style0 from "./uploadArquivos.vue?vue&type=style&index=0&id=d1a1f162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a1f162",
  null
  
)

export default component.exports